/*
 * Copyright (c) 2022
 *
 * Created Date: Wednesday, September 28th 2022, 12:42:35 pm
 * Author: aris bimas
 *
 */

import React from "react";
import { useTranslation } from "react-i18next";
import { BiLeftArrowAlt, BiRightArrowAlt } from "react-icons/bi";
import Loader from 'components/Common/Loader'

const Button = ({
  children,
  onClick = () => { },
  className = "",
  disabled = false,
}) => {
  return (
    <button className={`btn ${className}`} {...{ onClick }} disabled={disabled}>
      {children}
    </button>
  );
};

const ButtonPrimary = ({
  children,
  onClick = () => { },
  containerClass = "",
  disabled = false,
  loading = false,
  type = "",
  circleColor = "white"
}) => {
  return (
    <button
      className={`btn luna-btn-primary themebg-blue text-white ${containerClass}`}
      {...{ onClick }}
      disabled={disabled}
      type={type}>
      {loading ? <Loader.ButtonLoader color={circleColor} /> : children}
    </button>
  );
};

const ButtonDanger = ({
  children,
  onClick = () => { },
  containerClass = "",
  disabled = false,
}) => {
  return (
    <button
      className={`btn themebg-red text-white ${containerClass}`}
      {...{ onClick }}
      disabled={disabled}>
      {children}
    </button>
  );
};

const ButtonSecondary = ({
  children,
  onClick = () => { },
  containerClass = "",
  disabled = false,
  loading = false,
  type = ""
}) => {
  return (
    <button
      className={`btn themebg-gray96 text-blue outline-blue ${containerClass}`}
      {...{ onClick }}
      disabled={disabled}
    >
      {loading ? <Loader.ButtonLoader /> : children}
    </button>
  );
};

const ButtonDisabled = ({
  children,
  onClick = () => { },
  containerClass = "",
}) => {
  return (
    <button
      className={`btn themebg-black25 text-white outline-black25 ${containerClass}`}
      {...{ onClick }}
      disabled={true}
    >
      {children}
    </button>
  );
};

const ButtonDownload = ({
  children,
  onClick = () => { },
  containerClass = "",
  disabled = false,
  href = ""
}) => {
  return (
    <a
      className={`btn themebg-gray96 text-blue outline-blue ${containerClass}`}
      {...{ onClick }}
      disabled={disabled}
      download
      href={href}
    >
      {children}
    </a>
  );
};

const ButtonPlain = ({
  children,
  onClick = () => { },
  containerClass = "",
  disabled = false,
  loading = false,
  type = ""
}) => {
  return (
    <button
      className={`btn themetext-blue btn-plain fw-medium ${containerClass}`}
      {...{ onClick }}
      disabled={disabled}
    >
      {loading ? <Loader.ButtonLoader /> : children}
    </button>
  );
};

const ButtonPlainDanger = ({
  children,
  onClick = () => { },
  containerClass = "",
  disabled = false,
  loading = false,
  type = ""
}) => {
  return (
    <button
      className={`btn themetext-red btn-plain-danger ${containerClass}`}
      {...{ onClick }}
      disabled={disabled}
    >
      {loading ? <Loader.ButtonLoader /> : children}
    </button>
  );
};

const ButtonLightBg = ({
  children,
  onClick = () => { },
  containerClass = "",
  disabled = false,
  loading = false,
  type = ""
}) => {
  return (
    <button
      className={`btn themetext-blue bg-light-blue ${containerClass}`}
      {...{ onClick }}
      disabled={disabled}
    >
      {loading ? <Loader.ButtonLoader /> : children}
    </button>
  );
};

const ButtonNextChapter = ({onClick=()=>{}, numberLabel='', disabled=false}) => {
  const {t} = useTranslation()
  return (
    <a href="#" className={`btn-chapter-navigation btn-next ${disabled ? 'disabled' : ''}`} onClick={onClick}>
      <div className="label-wrapper">
        <span className="label">{t('detailChapter.nextChapter')}</span>
        <span className="numbering">{numberLabel}</span>
      </div>
      <div className="icon-wrapper">
        <BiRightArrowAlt />
      </div>
    </a>
  )
}

const ButtonPrevChapter = ({onClick=()=>{}, numberLabel='', disabled=false}) => {
  const {t} = useTranslation()
  return (
    <a href="#" className={`btn-chapter-navigation ${disabled ? 'disabled' : ''}`} onClick={onClick}>
      <div className="icon-wrapper">
        <BiLeftArrowAlt />
      </div>
      <div className="label-wrapper">
        <span className="label">{t('detailChapter.prevChapter')}</span>
        <span className="numbering">{numberLabel}</span>
      </div>
    </a>
  )
}
export { Button, ButtonPrimary, ButtonDanger, ButtonSecondary, ButtonDisabled, ButtonDownload, ButtonPlain, ButtonPlainDanger, ButtonLightBg, ButtonNextChapter, ButtonPrevChapter };
